import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../store/slices'
import { useEffect } from 'react'

const useFetchCgmOnboarding = (programType) => {
  const dispatch = useDispatch()
  const { onboardingLandingPage } = useSelector((state) => state.cgm)

  const fetchOnboardingLandingPage = (payload = {}) => {
    dispatch(
      actions.fetchCgmOnboardingLandingPageRequest({
        ...payload,
        programType: programType ?? payload.programType,
      }),
    )
  }

  useEffect(() => {
    if (programType) {
      fetchOnboardingLandingPage()
    }
  }, [programType])

  return {
    fetchOnboardingLandingPage,
    onboardingLandingPage,
    isLoading: onboardingLandingPage.loading,
    error: onboardingLandingPage.error,
    data: onboardingLandingPage.data,
  }
}

export default useFetchCgmOnboarding
